import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { breadcrumb, aboutPage } from '../lib/seo-schemas';

const TIMELINE = [
  { yr: '1928',     t: 'Fundación',          d: 'Apertura en C. Julián Ceballos. Nace la taberna que definiría el tapeo de Torrelavega.' },
  { yr: '1940s',    t: 'Posguerra',          d: 'El bar sobrevive los años difíciles. La barra siempre llena. Bocarte y conservas del Cantábrico.' },
  { yr: '1971',     t: 'Generación dorada',  d: 'Las gildas y las toreras del Cabrero se vuelven leyenda local. La receta toma forma definitiva.' },
  { yr: '1980–00',  t: 'Lugar de encuentro', d: 'Se consolida la Peña Cabrero de Mus. Torneos, amigos, cuadrillas. Comunidad.' },
  { yr: '2010',     t: 'Renacimiento',       d: 'Nueva dirección. Se respeta la decoración y se recupera la esencia artesanal con anchoas DOP.' },
  { yr: 'Hoy',      t: '96 años y contando', d: 'La barra más alta de Torrelavega, más viva que nunca. Marcos Argumosa al frente.', current: true },
];

export default function Historia() {
  return (
    <>
      <Seo
        title="Nuestra Historia desde 1928"
        description="Casi un siglo de aperitivo en Torrelavega. La historia del Bar Cabrero (1928), la Peña de Mus, la barra más alta de Cantabria y Marcos Argumosa al frente."
        path="/historia"
        schemas={[
          breadcrumb([{ name: 'Historia', path: '/historia' }]),
          aboutPage({
            name: 'Historia del Bar Cabrero — desde 1928',
            description: 'Casi un siglo de hostelería en Torrelavega. Fundación en 1928, la Peña de Mus, la barra más alta de Cantabria y la dirección de Marcos Argumosa.',
            path: '/historia',
          }),
        ]}
      />

      <section className="hist-hero" data-testid="historia-page">
        <div>
          <p className="eyebrow rv" style={{ color: 'rgba(244,247,242,0.55)' }}>Nuestra historia</p>
          <h1 className="D D-xl rv" style={{ color: '#fff', marginBottom: '1.25rem' }}>
            Casi un siglo<br /><em style={{ color: 'var(--amber)' }}>en pie de barra.</em>
          </h1>
          <p className="rv" style={{ color: 'rgba(244,247,242,0.78)', lineHeight: 1.85, fontSize: '1rem', maxWidth: '34rem' }}>
            Desde 1928, el Bar Cabrero ha sido el corazón del aperitivo en Torrelavega. Generaciones de familias, cuadrillas de amigos, torneos de mus. Un bar que no ha necesitado reinventarse — solo mantenerse fiel a lo que siempre fue.
          </p>
          <div style={{ display: 'flex', gap: '0.85rem', flexWrap: 'wrap', marginTop: '1.75rem' }}>
            <Link to="/gildas" className="btn btn-a rv" data-testid="historia-cta-gildas">Conocer las gildas →</Link>
            <Link to="/visitanos" className="btn btn-w rv">Visítanos</Link>
          </div>
        </div>
        <div className="hist-yr rv">1928</div>
      </section>

      <div className="tl-scroll" data-testid="timeline">
        <div className="tl-track">
          {TIMELINE.map((it, i) => (
            <div className="tl-i rv" key={it.yr} data-testid={`timeline-${i + 1}`}>
              <div className="tl-dot" style={{ background: it.current ? 'var(--verde)' : 'var(--amber)' }} />
              <p className="tl-yr">{it.yr}</p>
              <p className="tl-t">{it.t}</p>
              <p className="tl-d">{it.d}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="gq-block" data-testid="historia-quote">
        <blockquote>
          "El Bar Cabrero no es un bar. Es la memoria líquida de Torrelavega — anchoa, oliva, guindilla y cuatro generaciones apoyadas en la misma barra."
        </blockquote>
        <cite>— Crónica local de Cantabria</cite>
      </div>

      <section className="sec" data-testid="historia-marcos">
        <div className="split col2">
          <div className="rv">
            <p className="eyebrow">Al frente</p>
            <h2 className="D D-lg" style={{ marginBottom: '1rem' }}>Marcos Argumosa,<br /><em>la nueva generación.</em></h2>
            <p className="lead" style={{ marginBottom: '1rem' }}>
              Marcos cogió las riendas del Cabrero con una idea clara: respetar todo lo que hace al bar único, y empujar suave hacia el futuro.
            </p>
            <p className="copy">
              Misma decoración, misma barra alta, misma receta de gilda. Y a la vez: anchoa DOP, blanco de la Nava bien tirado, vermut de grifo los domingos. Tradición y mimo.
            </p>
          </div>
          <div className="rv">
            <div className="fcard"><h4>La barra más alta de Torrelavega</h4><p>Varios palmos por encima de lo habitual. Un detalle que nadie olvida y que define el carácter del Cabrero.</p></div>
            <div className="fcard"><h4>La Peña Cabrero de Mus</h4><p>Décadas de torneos entre estas paredes. Un bar que construye comunidad, no solo aperitivo.</p></div>
            <div className="fcard"><h4>Encuentro entre generaciones</h4><p>Los jóvenes redescubren las gildas. Los mayores llevan décadas en esta barra. Aquí se cruzan.</p></div>
          </div>
        </div>
      </section>
    </>
  );
}
